export const AppRoutes = {
    home:'/',
    app:'/app',
    docs:'/docs',
    compareToNimbleText:'/compare-to-nimble-text',
}